import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import {
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import * as productManagement from "../../../services/productManagement";
import { useNavigate, useParams } from "react-router-dom";

const EditGroupings = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [submitted, setSubmitted] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);
    const [initialValues, setInitialValues] = useState({
        title: "",
    });
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: "Grouping", url: "" },
    ];
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        if (id) {
            productManagement
                .GroupingDetails({ _id: id })
                .then((response) => {
                    if (response.success) {
                        setInitialValues({
                            title: response?.data?.title || "",
                        });
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        }
    }, [id]);

    const validationSchema = Yup.object().shape({
        title: Yup.string()
            .trim()
            .required('label_title_error')
            .max(50, 'label_title_length_error_50'),
    });

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <Formik
                validateOnChange={true}
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitted(true);
                    let formData = {
                        _id: id,
                        title: values.title
                    };

                    productManagement
                        .EditGrouping(formData)
                        .then((response) => {
                            if (response.success) {
                                setRefresh((prev) => !prev);
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                setTimeout(() => {
                                    setSubmitted(false);
                                }, 2000);
                                navigate(`/admin/productManagement/groupings/list/1`);
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                setSubmitted(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting, setFieldTouched }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">Edit Grouping</h6>
                                        </div>
                                        <div className="row row-sm">
                                            <div className="col-md-12 text-center form-group">
                                                <label htmlFor="title" className="text-left d-flex">
                                                    {t("title")}: <span className="requirestar">*</span>{" "}
                                                </label>
                                                <input
                                                    name="title"
                                                    id="title"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.title}
                                                    className="form-control"
                                                    placeholder="Enter title"
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.title && touched.title && t(errors.title)}</span>
                                            </div>

                                            <div className="">
                                                <button
                                                    className="btn btn-main-primary signbtn mr-2"
                                                    type="submit"
                                                    disabled={submitted ? true : null}
                                                    onClick={() => {
                                                        setSubmitClicked(true);
                                                    }}
                                                >
                                                    <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                    {t("btn_submit")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default EditGroupings;
